export enum PromptType {
  CLASSIFICATION = 'classification',
  MODERATION = 'moderation',
}
